import type { WorkflowNode, ServiceComparisonRow } from "@/types/detail";

/** Default development workflow shown on service pages (interactive). */
export const DEV_WORKFLOW: WorkflowNode[] = [
  {
    label: "Discover",
    description:
      "We run focused workshops to understand your goals, users and constraints, then agree on scope, success metrics and a realistic budget.",
  },
  {
    label: "Design",
    description:
      "We prototype the experience and validate it with real users, refining flows and interface until the direction is clearly right.",
  },
  {
    label: "Build",
    description:
      "Senior engineers ship in short, tested iterations. You see working software every week and can steer as priorities evolve.",
  },
  {
    label: "Launch",
    description:
      "We handle release, monitoring and rollout carefully — so go-live is a calm, well-rehearsed event rather than a gamble.",
  },
  {
    label: "Support",
    description:
      "After launch we monitor, optimise and iterate, turning real usage data into a steady stream of improvements.",
  },
];

/** Shared comparison used on solution pages: spreadsheets vs generic vs custom. */
export const SHARED_COMPARISON: ServiceComparisonRow[] = [
  {
    aspect: "Fit to your process",
    spreadsheet: "You bend your process to the file",
    generic: "Compromise on rigid, fixed workflows",
    vibewell: "Shaped exactly around how you work",
  },
  {
    aspect: "Data integrity",
    spreadsheet: "Error-prone, easily overwritten",
    generic: "Better, but siloed per tool",
    vibewell: "Single source of truth with validation",
  },
  {
    aspect: "Automation",
    spreadsheet: "Manual, repetitive work",
    generic: "Limited, often locked behind tiers",
    vibewell: "Automations built for your workflow",
  },
  {
    aspect: "Scale & growth",
    spreadsheet: "Breaks down as you grow",
    generic: "Per-seat costs climb quickly",
    vibewell: "Scales with users and data cost-effectively",
  },
  {
    aspect: "Ownership",
    spreadsheet: "Fragile, undocumented knowledge",
    generic: "You rent; vendor controls the roadmap",
    vibewell: "You own the code, data and roadmap",
  },
];
